import Container from "@components/shared/Container";
import Card from "@components/shared/Card";

import AddDirectionForm from "@components/form/direction/AddDirectionForm";
import DirectionsTable from "@components/stat/direction/table/DirectionsTable";

const DirectionsTab: React.FC = () => (
  <Container title="Управление направлениями">
    <Card title="Добавить направление">
      <AddDirectionForm />
    </Card>
    <Card>
      <DirectionsTable />
    </Card>
  </Container>
);

export default DirectionsTab;
